import { LabelData } from 'label/utils/types';

/**
 * this handles the "printed" checkboxes under inventory > print labels
 * ensures they update appropriately when labels are printed from this view

 *
 * @param {Array} labelData
 */
export const handlePrintedCheckboxes = (labelData: LabelData[]) => {
  const printedCheckboxes = Array.from(
    document.getElementsByName('printed') as NodeListOf<HTMLInputElement>
  );

  if (!printedCheckboxes.length || !labelData.length) return;

  const length = labelData.length;

  if (printedCheckboxes.length === length) {
    for (let i = 0; i < printedCheckboxes.length; i++) {
      printedCheckboxes[i].checked = true;
    }

    return;
  }

  for (let i = 0; i < length; i++) {
    const { description } = labelData[i].Item;
    const itemDescriptionSpanArray = Array.from(
      document.querySelectorAll('a[title="Edit Record"] > span')
    );
    const el = itemDescriptionSpanArray.find(element => element.innerHTML === description);
    const index = el?.closest('td')?.id.replace(/\D/g, '');
    if (!index) {
      continue;
    }
    const checkbox = document.getElementById(`listing_printed${index}`) as HTMLInputElement;
    checkbox.checked = true;
  }
};
